export { default } from './AbilityLevelsSpotDescriptor';
